import { VStack } from '@chakra-ui/react'
import { Body, Button } from '@missionlabs/react'
import { AddCircleIcon } from '@missionlabs/react/circleloop'
import { Destination, DestinationTypes } from '@missionlabs/types'
import { SettingsTitle } from 'features/settings/components/SettingsTitle'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { SettingsPage } from 'shared/components/settings/SettingsPage'

import { DevicesTable } from './DevicesTable'

export interface DevicesProps {
    destinations: Destination[]
    isLoading: boolean
}

const allowedDestinations = [
    DestinationTypes.desktopApp,
    DestinationTypes.webApp,
    DestinationTypes.android,
    DestinationTypes.ios
]

const selectDestinations = (data: Destination[]) =>
    data.filter(item => allowedDestinations.includes(item.type))

const selectManualDestinations = (data: Destination[]) =>
    data.filter(item => !allowedDestinations.includes(item.type))

export const Devices: FC<DevicesProps> = ({ destinations, isLoading }) => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <SettingsPage
            title={t('devices.Devices')}
            actions={
                <Button
                    variant="creationary"
                    leftIcon={<AddCircleIcon />}
                    onClick={() => navigate('/settings/devices/add')}
                >
                    {t('devices.addDevice')}
                </Button>
            }
        >
            <SettingsTitle label={t('settings.automaticallyAddedDevices')} divider={false} />
            <DevicesTable data={selectDestinations(destinations)} isLoading={isLoading} />
            <VStack spacing={0} align="inherit">
                <SettingsTitle label={t('settings.manuallyAddedDevices')} divider={false} />
                <Body>{t('settings.manuallyAddedDevicesSubtext')}</Body>
            </VStack>
            <DevicesTable data={selectManualDestinations(destinations)} isLoading={isLoading} />
        </SettingsPage>
    )
}
